import Captcha from '../captcha';
import MessageBox from '../message-box';
import createPopupCaptcha from './popup-captcha.js';

export let _Vue;

export default {
  install(Vue) {
    _Vue = Vue;
    Vue.use(Captcha);
    Vue.use(MessageBox);
    Vue.prototype.$createPopupCaptcha = createPopupCaptcha;
  }
};
